function Spinner() {
   this.spinnerHtml = '<div class="sk-spinner sk-spinner-three-bounce">'+
                           '<div class="sk-bounce1"></div>'+
                           '<div class="sk-bounce2"></div>'+
                           '<div class="sk-bounce3"></div>'+
                       '</div>';
}
Spinner.prototype.addToBtn = function(btn) {
    console.log(this.spinnerHtml);
    btn.html(this.spinnerHtml);

};
function showNmoModal(){

    if($.cookie('stop_nmo_modal') != 1){

        $("#nmoModal").modal('show');

    }

}
function stopNmoModal(){

    $.cookie('stop_nmo_modal', 1, { expires: 365 });

}
function sendYearSertificate(){

    $.ajax({
        url:'/site/add-certificate-year',
        type: "POST",
        data: {
            _csrf:getCsrf(),
            id:$("#certificateYearForm [name=id]:checked").val()
        },
        success:function (){
            $("#sendYearSertificate").remove();
            $("#ok").removeClass('hide');
            $("#certificateYearForm").hide();

        }
    });
}
function getCsrf(){
    return $("meta[name=csrf-token]").attr("content");
};
$(function () {
    $('[data-toggle="popover"]').popover({
        html:true,
        placement:'top'
    });
    $('[data-toggle="tooltip"]').tooltip({ placement:'top'});

    if($('#nmoModal').length > 0 && $.cookie('stop_nmo_modal') != 1){

        showNmoModal();

    } else if($("#certificateYear").length > 0){

      //  $("#certificateYear").modal('show');

    }
});


